// Globally and automatically registers the base components in components/common.

const requireComponent = require.context(
    // The relative path of the components folder
    '@/components/common',
    // Whether or not to look in subfolders
    false,
    // The regular expression used to match base component filenames
    /[A-Z]\w+\.(vue|js)$/
)

function toPascalCase(str) {
    return str
        .replace(/[-_](\w)/g, (_, c) => c.toUpperCase())
        .replace(/^(\w)/, (_, c) => c.toUpperCase())
}

export default {
    install(app) {
        requireComponent.keys().forEach(fileName => {
            const componentConfig = requireComponent(fileName)

            const componentName = toPascalCase(
                fileName
                    .split('/')
                    .pop()
                    .replace(/\.\w+$/, '')
            )

            app.component(
                componentName,
                componentConfig.default || componentConfig
            )
        })
    }
}
